import ContentLoader from 'react-content-loader';
import { useWindowDimensions } from '../../../hooks/common/useWindowDimensions';

export const AdvertLoader = () => {
    const { height } = useWindowDimensions();
    return (
        <ContentLoader viewBox={`0 0 ${height * 0.335} 70`} className="card">
            <rect x="0" y="0" rx="1" ry="1" width="70" height="70" />
            <rect x="80" y="17" rx="4" ry="4" width="300" height="13" />
            <rect x="80" y="40" rx="3" ry="3" width="250" height="10" />
        </ContentLoader>
    );
};

export const FilterLoader = () => {
    return (
        <ContentLoader viewBox="0 0 300 15">
            <rect x="0" y="3" rx="1" ry="1" width="75" height="12" />
        </ContentLoader>
    );
};

export const AdvertLoadersList = () => {
    return (
        <>
            <FilterLoader />
            <AdvertLoader />
            <AdvertLoader />
            <AdvertLoader />
            <AdvertLoader />
            <AdvertLoader />
            <AdvertLoader />
            <AdvertLoader />
            <AdvertLoader />
            <AdvertLoader />
            <AdvertLoader />
        </>
    );
};
